module.exports = __webpack_public_path__ + "static/media/phone-gray.f808826d.svg";